<template>
    <div class="view pt-[130px] pb-[144px] bg-white z-[3]">
        <div class="container">
            <div class="max-w-[634] mx-auto">
                <h4 class="text-violet font-bold text-[20px] mb-[20px] font-title">HOW IT WORKS</h4>
                <h2 class="md:text-[30px] md:leading-[38px] text-[26px] leading-[34px] font-bold  mb-[40px] font-title">In this quiz, you’ll be presented with seven multiple choice questions.</h2>
                <p class="mb-[30px]">
                    Each answer will relate to a KPMG-me, a personality type that will help you understand yourself,
                    build your brand essentials, and see how you belong at KPMG. You’ll be assigned a KPMG-me once the
                    quiz is finished.
                </p>
                <p class="mb-[30px]">
                    All you need to do is choose the answer that best reflects your personality!
                </p>

                <Button color="rose" @click="$store.commit('showQuiz')">
                    Ready? Let’s go
                    <font-awesome-icon icon="fa-regular fa-arrow-right" />
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/Button.vue';

export default {
    name: 'ConfirmView',
    components: {
        Button
    }
}
</script>